/**
 * Listen to some specific button clicks and smooth scroll without attaching anything to url
 */
;(function (window, document) {

    'use strict'

	function smoothScrollInit() {

		// get all links where the href starts with #
		var addToCartButtons = document.querySelectorAll("a[href^='#']");

		if ( addToCartButtons ) {
			for (var i = 0; i < addToCartButtons.length; i++) {
				addToCartButtons[i].addEventListener("click", function(element) {

					element.preventDefault();

					// get href
					let elementTarget = element.currentTarget.getAttribute("href");

					// remove the first character "#"
					elementTarget     = elementTarget.substring(1);

					// scroll to target if there is a target
					if ( elementTarget ) {
						document.getElementById(elementTarget).scrollIntoView({
							behavior: 'smooth',
						});
					}
				}, false);
			}
		}
	}

	// Start smooth scroll listeners when the page is ready.
	window.addEventListener('DOMContentLoaded', () => {
		smoothScrollInit();
	})

})(window, document)